'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

import { PRESSURE_CARD_SCROLL_END_THRESHOLD_PX } from '@/constants/pressureCards';

export function usePressureCardScrollCue(active: boolean) {
  const viewportRef = useRef<HTMLDivElement>(null);
  const [hasMoreContent, setHasMoreContent] = useState(false);

  const updateScrollCue = useCallback(() => {
    const viewport = viewportRef.current;
    if (viewport == null) return;

    const remainingScroll =
      viewport.scrollHeight - viewport.clientHeight - viewport.scrollTop;
    setHasMoreContent(
      remainingScroll > PRESSURE_CARD_SCROLL_END_THRESHOLD_PX,
    );
  }, []);

  useEffect(() => {
    if (!active) return;

    const viewport = viewportRef.current;
    if (viewport == null) return;

    const animationFrame = window.requestAnimationFrame(updateScrollCue);
    const resizeObserver =
      typeof ResizeObserver === 'undefined'
        ? null
        : new ResizeObserver(updateScrollCue);

    resizeObserver?.observe(viewport);
    const content = viewport.firstElementChild;
    if (content != null) resizeObserver?.observe(content);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      resizeObserver?.disconnect();
    };
  }, [active, updateScrollCue]);

  return {
    viewportRef,
    showScrollCue: active && hasMoreContent,
    updateScrollCue,
  };
}
